import axios from 'axios';
import { auth } from './firebase';
import { signOut } from 'firebase/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

const upload = axios.create({
  baseURL: process.env.REACT_APP_UPLOAD_API,
});

api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;

  if (user) {
    try {
      const token = await user.getIdToken(true);
      config.headers['Authorization'] = `Bearer ${token}`;
    } catch (error) {
      console.error('Error getting token in interceptor:', error);
      await signOut(auth);
      window.location.replace('/sign-in');
      return Promise.reject(error);
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { response, config } = error;

    // Handle any 403 or 401 error as potential token issue
    if (response?.status === 403 || response?.status === 401) {
      const errorCode = response?.data?.code;

      // Try to refresh token for any auth-related error
      if (
        errorCode === 'firebase-expired-token' ||
        errorCode === 'firebase-invalid-token' ||
        errorCode === 'FIREBASE_INVALID_TOKEN' ||
        response?.status === 403 || // Any 403
        response?.status === 401    // Any 401
      ) {
        // Prevent infinite retry loop
        if (config._retry) {
          await signOut(auth);
          window.location.replace('/sign-in');
          return Promise.reject(error);
        }

        try {
          const user = auth.currentUser;
          if (user) {
            console.log('Refreshing token due to auth error...');
            const newToken = await user.getIdToken(true);
            
            // Mark this request as a retry
            config._retry = true;
            config.headers['Authorization'] = `Bearer ${newToken}`;
            
            return api(config);
          } else {
            throw new Error('Usuario no autenticado');
          }
        } catch (refreshError) {
          console.error('Error refreshing token:', refreshError);
          await signOut(auth);
          window.location.replace('/sign-in');
        }
      }
    }
    return Promise.reject(error);
  }
);
export { api, upload };
